import React from "react";
import { AlertTriangle, X } from "lucide-react";

export default function NewConfirmModal({ isOpen, onClose, onConfirm }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-5 space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="text-base font-semibold text-bookish-purple">Clear Newsletter</h3>
          <button type="button" onClick={onClose} className="p-1 hover:bg-bookish-purple/10 rounded-lg transition-colors">
            <X size={18} />
          </button>
        </div>

        <div className="flex flex-col items-center gap-3 py-2">
          <p className="text-sm text-bookish-purple/70 text-center">
            This will clear all content, design settings, and subject line. Any unsaved changes will be lost.
          </p>
        </div>

        <div className="flex gap-2 pt-2 border-t border-bookish-purple/8">
          <button
            onClick={() => { onConfirm(); onClose(); }}
            className="flex-1 px-3 py-2 text-sm font-medium rounded-lg bg-bookish-royal text-white hover:bg-bookish-purple transition-colors"
          >
            Continue
          </button>
          <button
            onClick={onClose}
            className="flex-1 px-3 py-2 text-sm font-medium rounded-lg border border-bookish-purple/15 hover:bg-bookish-purple/5"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
